// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import type { WebSocketMessage } from '../../types/game';

/**
 * Validate that a parsed JSON value conforms to the WebSocketMessage shape.
 * Returns the typed message if valid, or null if malformed.
 */
export function validateWebSocketMessage(data: unknown): WebSocketMessage | null {
  if (data === null || typeof data !== 'object') {
    return null;
  }

  const obj = data as Record<string, unknown>;

  if (typeof obj.action !== 'string' || obj.action === '') {
    return null;
  }

  // payload must be an object (or missing, in which case default to {})
  if (obj.payload !== undefined && (typeof obj.payload !== 'object' || obj.payload === null)) {
    return null;
  }

  return {
    action: obj.action,
    payload: (obj.payload as Record<string, unknown>) ?? {},
  } as WebSocketMessage;
}
